"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFiftyNineHalf = exports.toTz = exports.isAtLeast1900 = exports.isEighteen = exports.dateIsValid = exports.dateFromDefaultFormat = exports.dateFromDisplayFormat = exports.DEFAULT_FORMAT = exports.DISPLAY_FORMAT = void 0;

var _parse = _interopRequireDefault(require("date-fns/parse"));

var _is_valid = _interopRequireDefault(require("date-fns/is_valid"));

var _add_years = _interopRequireDefault(require("date-fns/add_years"));

var _add_months = _interopRequireDefault(require("date-fns/add_months"));

var _is_before = _interopRequireDefault(require("date-fns/is_before"));

var _end_of_day = _interopRequireDefault(require("date-fns/end_of_day"));

var _get_year = _interopRequireDefault(require("date-fns/get_year"));

var _add_hours = _interopRequireDefault(require("date-fns/add_hours"));

var DISPLAY_FORMAT = 'MM/DD/YYYY';
exports.DISPLAY_FORMAT = DISPLAY_FORMAT;
var DEFAULT_FORMAT = 'YYYY-MM-DD';
exports.DEFAULT_FORMAT = DEFAULT_FORMAT;
var regexp = /^$|^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;

var dateFromDisplayFormat = function dateFromDisplayFormat(v) {
  return v ? (0, _parse["default"])(v, DISPLAY_FORMAT) : null;
};

exports.dateFromDisplayFormat = dateFromDisplayFormat;

var dateFromDefaultFormat = function dateFromDefaultFormat(v) {
  return v ? (0, _parse["default"])(v, DEFAULT_FORMAT) : null;
};

exports.dateFromDefaultFormat = dateFromDefaultFormat;

var dateIsValid = function dateIsValid(v) {
  return !v || v.match(regexp) && (0, _is_valid["default"])(dateFromDisplayFormat(v));
};

exports.dateIsValid = dateIsValid;

var isEighteen = function isEighteen(v) {
  return dateIsValid(v) ? (0, _is_before["default"])((0, _add_years["default"])(dateFromDisplayFormat(v), 18), (0, _end_of_day["default"])(new Date())) : true;
};

exports.isEighteen = isEighteen;

var isAtLeast1900 = function isAtLeast1900(v) {
  return dateIsValid(v) ? (0, _get_year["default"])(dateFromDisplayFormat(v)) >= 1900 : true;
};

exports.isAtLeast1900 = isAtLeast1900;

var toTz = function toTz() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -8;
  return (0, _add_hours["default"])(new Date(date.toUTCString().substr(0, 25)), offset);
}; // TODO: should handle both formats for date


exports.toTz = toTz;

var isFiftyNineHalf = function isFiftyNineHalf(v) {
  return (0, _is_before["default"])((0, _add_months["default"])((0, _add_years["default"])(dateFromDefaultFormat(v), 59), 6), (0, _end_of_day["default"])(new Date()));
};

exports.isFiftyNineHalf = isFiftyNineHalf;